module.exports = __webpack_public_path__ + "img/browse-vehicles-background-nissan.e94a2010.png";